import classes from './Notifications.module.scss';
import { useState, useEffect } from 'react';
import Markdown from 'markdown-to-jsx';
import Badge from '../../../../atoms/badge/Badge';
import Image from 'next/image';

export default function Notifications({ data }) {
    const [badgeId, setBadgeId] = useState('');
    const [systemSettings, setSystemSettings] = useState('');
    const [copy, setCopy] = useState('');

    const { title: site_header, copy: site_description } = data[0];
    const { operating_system_settings, device_settings, notifications_settings } = data[1];
    const OPERATING_SYSTEM_SETTINGS = data[2].title;
    const DEVICE_SETTINGS = data[3].title;
    const NOTIFICATIONS_SETTINGS = data[4].title;

    useEffect(() => {
        const { copy, title } = operating_system_settings[0];
        setSystemSettings(OPERATING_SYSTEM_SETTINGS);
        setCopy(copy);
        setBadgeId(title);
    }, [data]);

    const onClick = (event, settingsList, systemSettings) => {
        setBadgeId(event.target.id);
        setSystemSettings(systemSettings);
        setCopy(settingsList);
    };

    const badgeTheme = (text, settings) => {
        if (text === badgeId && settings === systemSettings) return 'blue';
        else return 'grey';
    };

    return (
        <div className={classes.oNotificationsSectionBlock}>
            <div className={`${classes.oNotificationsDivOne} fontRTL`}>
                <h3 className={`${classes.aTitle} fnt24f fnt-b`}>{site_header}</h3>
                <Markdown className={`${classes.aText} ${classes.aDescriptionText} fnt14r`}>
                    {site_description}
                </Markdown>
            </div>
            <div className={classes.oNotificationsDivTwo}>
                <div className={classes.oNotificationsInforContainer}>
                    <div className={classes.operatingSystemContainer}>
                        <div>
                            <h3 className={`${classes.aTitle} ${classes[`${'underline'}`]} fnt16f`}>
                                {OPERATING_SYSTEM_SETTINGS}
                            </h3>

                            <div className={classes.operatingSystemBadge}>
                                {operating_system_settings.map((badgeData, index) => (
                                    <Badge
                                        onClick={(event) => {
                                            onClick(
                                                event,
                                                badgeData.copy,
                                                OPERATING_SYSTEM_SETTINGS
                                            );
                                        }}
                                        text={badgeData.title}
                                        theme={badgeTheme(
                                            badgeData.title,
                                            OPERATING_SYSTEM_SETTINGS
                                        )}
                                        key={index}
                                        hasBorder={true}
                                        width="inline"
                                    />
                                ))}
                            </div>
                        </div>
                        <div>
                            <h3 className={`${classes.aTitle} ${classes[`${'underline'}`]} fnt16f`}>
                                {DEVICE_SETTINGS}
                            </h3>
                            <div className={classes.operatingSystemBadge}>
                                {device_settings.map((badgeData, index) => (
                                    <Badge
                                        onClick={(event) => {
                                            onClick(event, badgeData.copy, DEVICE_SETTINGS);
                                        }}
                                        text={badgeData.title}
                                        theme={badgeTheme(badgeData.title, DEVICE_SETTINGS)}
                                        key={index}
                                        hasBorder={true}
                                        width="inline"
                                    />
                                ))}
                            </div>
                        </div>
                        <div>
                            <h3 className={`${classes.aTitle} ${classes[`${'underline'}`]} fnt16f`}>
                                {NOTIFICATIONS_SETTINGS}
                            </h3>
                            <div className={classes.operatingSystemBadge}>
                                {notifications_settings.map((badgeData, index) => (
                                    <Badge
                                        onClick={(event) => {
                                            onClick(event, badgeData.copy, NOTIFICATIONS_SETTINGS);
                                        }}
                                        text={badgeData.title}
                                        theme={badgeTheme(badgeData.title, NOTIFICATIONS_SETTINGS)}
                                        key={index}
                                        hasBorder={true}
                                        width="inline"
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                    <figure className={classes.aOperatingSystemIcon}>
                        <Image
                            src="/web/images/operating-system.svg"
                            alt="operating"
                            width={19.5}
                            height={39}
                            layout="responsive"
                        />
                    </figure>
                    <div className={`${classes.batteryOptimizationSettings} fontRTL`}>
                        <Markdown className={`${classes.aText} ${classes.aDescriptionText} fnt14r`}>
                            {copy}
                        </Markdown>
                    </div>
                </div>
            </div>
        </div>
    );
}
